import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, catchError, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/ApiResponse';
import { Location } from '../../models/Location/Location';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly http = inject(HttpClient);
  private URL_API = environment.apiUrl;

  getDetailByKey(customerId: number, locationKey: string): Observable<ApiResponse<Location> | null> {
    const params = new HttpParams()
      .set('customerId', customerId.toString())
      .set('key', locationKey);

    return this.http
      .get<ApiResponse<Location>>(`${this.URL_API}/api/Location/Detail/Key`, { params })
      .pipe(
        take(1),
        catchError(() => of(null))
      );
  }
}
